import { Card, CardContent, CircularProgress, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles = makeStyles((theme) => ({
  root: {},
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  }
}));


function MaterialFindDetail({ className, MaterialFindData, Loading }) {
  const classes = useStyles();




  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {Loading ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                :
                MaterialFindData.length > 0 && MaterialFindData.map(item => (
                  <List className={classes.root} key={item.KUL_BIRIM_KODU}>
                    <ListItem alignItems="flex-end">
                      <ListItemAvatar key={item.KUL_BIRIM_KODU}>
                        <Typography
                          component="span"
                          variant="h6"
                          color="textPrimary">
                          {item.KUL_BIRIM_KODU}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          color="textPrimary">{item.SERVIS}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          color="textPrimary">{item.UST_BIRIM_KODU}
                        </Typography>
                        <br></br>
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.MALZEME_STOK_NO + '-' + item.MALZEME}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >                              
                              <b>ToplamMevcutAdet:</b> {item.TOPLAM_MEVCUT_ADET}
                              <br />
                              <b>ZimmetAdet:</b> {item.TEKNISYEN_ZIMMET_ADET}
                              <br />
                              <b>KullanılabilirAdet:</b> {item.KULLANILABILIR_ADET}
                              <br />
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </List>
                ))}
            </div>
          </PerfectScrollbar>
        </CardContent>
      </Card>
    </div>
  );
}

MaterialFindDetail.propTypes = {
  className: PropTypes.string
};

export default MaterialFindDetail;
